import { Text } from '@audio-network/componentlibrary'
import { ReactNode } from 'react'

type Props = {
	children?: ReactNode
}

export default function ToastBold({ children }: Props): JSX.Element {
	return <Text bold>{children}</Text>
}
